import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router } from "react-router-dom";
import PublicationSearchPage from "./PublicationSearchPage";

const PublicationSearchPageWrapper = ({ filters }) => {
  return (
    <Router>
      <PublicationSearchPage filters={filters} />
    </Router>
  );
};

PublicationSearchPageWrapper.propTypes = {
  filters: PropTypes.object,
};

export default PublicationSearchPageWrapper;
